import { render, staticRenderFns } from "./tipoInstitucion.vue?vue&type=template&id=aecff22e&scoped=true"
import script from "./tipoInstitucion.vue?vue&type=script&lang=js"
export * from "./tipoInstitucion.vue?vue&type=script&lang=js"
import style0 from "./tipoInstitucion.vue?vue&type=style&index=0&id=aecff22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecff22e",
  null
  
)

export default component.exports